import React from 'react';
import {Card} from "antd";
import {compose} from "redux";
import {connect} from "react-redux";
import {createProjectRfi} from "../../../actions/rfis";
import {RfiForm} from "./RfiForm";
import {currentEffectiveUserId} from "../../../reducers/ui";

const RfiNew = props => {
  const { projectid, onSubmit, onCancel, userid } = props;
  return <Card title='Project Rfi Details' className={'edit-view'}>
    <RfiForm projectid={projectid} onCancel={onCancel} onSubmit={onSubmit} userid={userid}/>
  </Card>;
};

export default compose(
  connect(
    (state, props) => ({ projectid: props.match.params.id, userid: currentEffectiveUserId(state) }),
    (dispatch, props) => ({
      onSubmit: (rfi) => {
        return dispatch(createProjectRfi(props.match.params.id, rfi, (rfiid) => props.history.push(`/projects/${props.match.params.id}/rfis/${rfiid}`)));
      },
      onCancel: () => props.history.goBack()
    })
  )
)(RfiNew);



// WEBPACK FOOTER //
// ./src/components/Projects/Rfis/RfiNew.js